module.exports = __webpack_public_path__ + "img/pouletAigreDouce.11354ea3.jpg";